import type { VideoDto } from './videoDto';

/** Contenu d'une playlist, tel que renvoyé par le serveur (miroir du DTO serveur). */
export interface PlaylistDto {
	/** Titre de la playlist, s'il est connu. */
	title: string | null;
	/** Vidéos de la playlist, dans l'ordre de la playlist. */
	videos: VideoDto[];
}

/**
 * Interroge `GET /api/playlist` pour lister les vidéos d'une playlist.
 *
 * @param url - Lien de la playlist YouTube (`youtube.com/playlist?list=...`).
 * @returns Le titre et les vidéos de la playlist.
 * @throws {Error} Si la requête échoue ou si le serveur répond une erreur.
 */
export async function fetchPlaylist(url: string): Promise<PlaylistDto> {
	const params = new URLSearchParams({ url });

	let response: Response;
	try {
		response = await fetch(`/api/playlist?${params.toString()}`);
	} catch (error) {
		throw new Error('Impossible de contacter le serveur.', { cause: error });
	}

	if (!response.ok) {
		let message = `Échec du chargement de la playlist (${response.status}).`;
		try {
			const body = (await response.json()) as { error?: string };
			message = body.error ?? message;
		} catch {
			// Réponse d'erreur sans JSON exploitable : on garde le message par défaut.
		}
		throw new Error(message);
	}

	try {
		return (await response.json()) as PlaylistDto;
	} catch (error) {
		throw new Error('Réponse du serveur invalide.', { cause: error });
	}
}
